import React from 'react';
import { connect } from 'react-redux';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { favoriteDel, favoriteAdd } from 'services/api/user/favorite';
import { converter } from 'helpers/converter';
import * as actions from 'actions/response';
import * as constants from 'constants.js';
import * as caruselActions from 'action-creators/carousel';
import Metrics from 'services/metrics';
import { getCurrentNode } from '../../reducers/nav/selectors';

const GROUP_BUTTON_ADDFAN = 'grupo_button_addFan';
export class BtnCardFavorite extends React.Component {
  async onClick(group) {
    const {
      favorites,
      user,
      onFavoriteAdd,
      onFavoriteRemove,
      isSeenList,
      currentNode,
      index,
    } = this.props;

    const isFavorite = _.findIndex(favorites, { id: group.id }) !== -1;
    const isFavoriteNew = !isFavorite;
    const { userhash } = user;
    const groupWhitHash = group;
    groupWhitHash.user_hash = userhash;
    const params = {
      object_id: group.id,
      user_hash: userhash,
      object_type: 1,
    };

    if (isSeenList) {
      const metricsData = {
        section: currentNode.text,
        index,
      };
      this.props.onRemoveSeen(groupWhitHash, metricsData);
      return;
    }

    Metrics.newEvent({
      eventCategory: 'Remover de Carrusel',
      eventAction: currentNode.text,
      eventLabel: `${groupWhitHash?.format_types} - ${
        groupWhitHash?.title
      } – ${index} | Mi lista`,
    });

    if (isFavoriteNew) {
      onFavoriteAdd(groupWhitHash, params);
    } else {
      onFavoriteRemove(groupWhitHash, params);
    }
  }

  render() {
    const {
      group,
      user,
      favorites,
      isMyList,
      translations,
      isSeenList,
    } = this.props;
    let isLoading = false;

    if (group.id == null) {
      group.id = group.group_id;
    }

    if (user.userType === constants.ANONYMOUS_USER) {
      return null;
    }

    if (favorites == null) {
      isLoading = true;
    }

    const isFavorite =
      _.findIndex(favorites, { id: group.id }) !== -1 || isSeenList;
    const idName = !isLoading && !isFavorite ? 'card-add' : 'card-delete';
    if (isMyList || isSeenList) {
      return (
        <div
          style={{
            border: 'none',
            float: 'right',
          }}
          type="button"
          onClick={this.onClick.bind(this, group)}
        >
          <div className="item-btn-wrapper" id={idName}>
            <div className="btn item-fanbutton">
              {!isLoading && isFavorite && <i className="fa fa-trash-o" />}
            </div>
          </div>
        </div>
      );
    }
    return (
      <div type="button" onClick={this.onClick.bind(this, group)}>
        <div className="item-btn-wrapper" id={idName}>
          <div className="btn btn-default btn-circle btn-lg item-fanbutton">
            {isLoading && <i className="fa fa-refresh fa-spin" />}
            {!isLoading && !isFavorite && <i className="fa fa-plus" />}
            {!isLoading && isFavorite && <i className="fa fa-minus" />}
          </div>
        </div>
        <div className="item-btn-wrapper">
          <span className="padding-top-05">
            {converter.convertApa(translations, GROUP_BUTTON_ADDFAN)}
          </span>
        </div>
      </div>
    );
  }
}

BtnCardFavorite.propTypes = {
  group: PropTypes.object,
  translations: PropTypes.object,
  favorites: PropTypes.arrayOf(PropTypes.object),
  user: PropTypes.object,
  onFavoriteAdd: PropTypes.func,
  onFavoriteRemove: PropTypes.func,
  isMyList: PropTypes.bool,
  isSeenList: PropTypes.bool,
  name: PropTypes.string,
};

const mapStateToProps = state => ({
  favorites: state.favorites,
  user: state.user,
  config: state.config,
  currentNode: getCurrentNode(state),
});

const mapDispatchToProps = dispatch => ({
  onFavoriteAdd(group, params) {
    dispatch(actions.addFavorite(group));
    dispatch(favoriteAdd(params));
  },
  onFavoriteRemove(group, params) {
    dispatch(caruselActions.deleteFavorite(group.id));
    dispatch(actions.removeFavorite(group));
    dispatch(favoriteDel(params));
  },
  onRemoveSeen(group, metricsData) {
    dispatch(caruselActions.deleteSeenList(group, metricsData));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(BtnCardFavorite);
